const ENTITIES: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};

/** Escapes text for use in XML/SVG content and attribute values. */
export const escapeXml = (value: string): string => value.replace(/[&<>"']/g, (c) => ENTITIES[c]);

export const formatNumber = (value: number): string =>
    String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
